import { Routes } from '@angular/router';
import { AuthGuard, GuestGuard } from './auth/guards/auth.guard';
import { SaleGuard } from './ticket-purchase/guards/sale.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'cartelera',
    pathMatch: 'full',
  },
  {
    path: 'cartelera',
    loadComponent: () =>
      import('./billboard/pages/home-page/home-page.component').then(
        (m) => m.HomePageComponent
      ),
  },
  {
    path: 'confiteria',
    loadComponent: () =>
      import('./confectionery/pages/home-page/home-page.component').then(
        (m) => m.HomePageComponent
      ),
  },
  {
    path: 'pelicula/:id',
    loadComponent: () =>
      import('./movie/pages/home-page/home-page.component').then(
        (m) => m.HomePageComponent
      ),
  },
  {
    path: 'proximamente',
    loadComponent: () =>
      import('./soon/pages/home-page/home-page.component').then(
        (m) => m.HomePageComponent
      ),
  },
  {
    path: 'estreno/:id',
    loadComponent: () =>
      import('./movie/pages/soon-page/soon-page.component').then(
        (m) => m.SoonPageComponent
      ),
  },
  {
    path: 'comprar-boletos',
    canActivate: [AuthGuard, SaleGuard],
    loadComponent: () =>
      import(
        './ticket-purchase/pages/checkout-page/checkout-page.component'
      ).then((m) => m.CheckoutPageComponent),
  },
  {
    path: 'checkout',
    canActivate: [AuthGuard, SaleGuard],
    loadComponent: () =>
      import(
        './ticket-purchase/pages/checkout-page/checkout-page.component'
      ).then((m) => m.CheckoutPageComponent),
  },
  {
    path: 'confirmacion',
    loadComponent: () =>
      import(
        './ticket-purchase/pages/payment-confirmation/payment-confirmation.component'
      ).then((m) => m.PaymentConfirmationComponent),
  },
  {
    path: 'pqrs',
    loadComponent: () =>
      import('./pqrs/pages/home-page/home-page.component').then(
        (m) => m.HomePageComponent
      ),
  },
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        canActivate: [GuestGuard],
        loadComponent: () =>
          import('./auth/pages/login-page/login-page.component').then(
            (m) => m.LoginPageComponent
          ),
      },
      {
        path: 'profile',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./auth/pages/profile-page/profile-page.component').then(
            (m) => m.ProfilePageComponent
          ),
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'cartelera',
  },
];
